<div>
	<p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" [resizable]="false"
			  [style]="{'width': '1120px', 'height': '900px'}">

		<p-header>
			<span>SNMP IF History</span>
		</p-header>

		<snmpif-history [visible]="visible"
						[monitorType]="monitorType" 
						[deviceGuid]="deviceGuid"
						[monitorPolicyGuid]="monitorPolicyGuid"></snmpif-history>

		<p-footer>
			<button type="button" pButton icon="fa fa-close" (click)="hide()" label="Close"></button>
		</p-footer>

	</p-dialog>

</div>